const actionTypes = {
  FetchCurrentOrder: 'FETCH_CURRENT_ORDER',
  DriverFetched: 'DRIVER_FETCHED',
  LoadOrderHistory: 'LOAD_ORDER_HISTORY',
  FetchDriverRunOrder: 'FETCH_DRIVER_RUN_ORDER',
};

export default actionTypes;
